var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAirbnbIllustration = function SvgAirbnbIllustration(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 65 63"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#airbnbIllustration_svg__a)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.563,
    cy: 30.628,
    fill: "#fff",
    rx: 28.913,
    ry: 27.628
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#airbnbIllustration_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FF5A5F",
    d: "M49.23 37.44c-.193-.462-.386-.963-.579-1.387-.308-.694-.617-1.35-.886-1.966l-.039-.039a402 402 0 0 0-8.52-17.424l-.115-.232a79 79 0 0 1-.925-1.811c-.386-.694-.771-1.427-1.388-2.12-1.234-1.543-3.007-2.39-4.896-2.39-1.927 0-3.662.847-4.934 2.312-.579.694-1.003 1.427-1.388 2.12-.308.617-.617 1.234-.925 1.812l-.116.232c-2.968 5.782-5.86 11.642-8.52 17.424l-.038.077c-.27.617-.578 1.273-.887 1.966q-.288.636-.578 1.388c-.501 1.427-.655 2.776-.463 4.164a8.19 8.19 0 0 0 5.012 6.399 7.9 7.9 0 0 0 3.122.617 9 9 0 0 0 1.003-.077c1.272-.155 2.583-.579 3.855-1.311 1.58-.887 3.084-2.159 4.78-4.01 1.696 1.851 3.238 3.123 4.78 4.01 1.272.732 2.583 1.156 3.855 1.31a9 9 0 0 0 1.003.078c1.079 0 2.158-.193 3.122-.617 2.699-1.08 4.588-3.547 5.012-6.4.308-1.349.154-2.698-.347-4.124m-17.386 2.005c-2.082-2.621-3.431-5.088-3.894-7.17-.193-.886-.231-1.657-.116-2.351a3.74 3.74 0 0 1 .617-1.62c.733-1.04 1.966-1.696 3.392-1.696 1.427 0 2.699.617 3.393 1.697a3.74 3.74 0 0 1 .617 1.619c.115.694.077 1.503-.116 2.351-.462 2.043-1.812 4.51-3.894 7.17m15.381 1.812a5.73 5.73 0 0 1-3.508 4.51c-.925.386-1.928.502-2.93.386-.964-.116-1.927-.424-2.93-1.002-1.388-.771-2.775-1.966-4.394-3.74 2.544-3.122 4.086-5.975 4.664-8.52a9.7 9.7 0 0 0 .193-3.276 6.26 6.26 0 0 0-1.04-2.621c-1.196-1.735-3.2-2.737-5.437-2.737-2.235 0-4.24 1.04-5.435 2.737a6.26 6.26 0 0 0-1.04 2.621 8 8 0 0 0 .192 3.277c.578 2.544 2.159 5.435 4.664 8.558-1.58 1.773-3.006 2.968-4.394 3.74-1.003.578-1.966.886-2.93 1.002a6.17 6.17 0 0 1-2.93-.386 5.73 5.73 0 0 1-3.508-4.51 6.4 6.4 0 0 1 .347-3.007c.116-.386.308-.771.501-1.234.27-.617.578-1.272.887-1.927l.038-.077a421 421 0 0 1 8.481-17.31l.116-.23c.308-.579.617-1.196.925-1.774.309-.617.656-1.195 1.08-1.696.81-.925 1.889-1.426 3.084-1.426s2.274.5 3.084 1.426c.424.501.77 1.08 1.079 1.696.308.578.617 1.195.925 1.774l.116.23a511 511 0 0 1 8.442 17.348v.039c.309.617.579 1.31.887 1.927.193.463.386.848.501 1.234.309 1.002.424 1.966.27 2.968"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "airbnbIllustration_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13.572 10.07H49.81v38.55H13.572z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "airbnbIllustration_svg__a",
    width: 64.249,
    height: 61.68,
    x: 0.08,
    y: 0.43,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.642,
    dy: 0.642
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.606
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_420_1169"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_420_1169",
    result: "shape"
  })))));
};
export default SvgAirbnbIllustration;